export const pubKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3S/EvmxPfUGegIue4526GQ0MHcxEZxH1KmlKeYIBYFyFOaj8QsvA4Bv6l8N0slMfy4oMjh47IMi3o41p0AR1gWwAw9MtO5/lA3PirhHBQnrTkTsuZ2sE7NVhZegpLzccs8Za5+TFA9Sc2WoxC8N8lnzMDQ6DQ9B9y+xPuxdZq8wIDAQAB"

export const priKey = "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBALdL8S+bE99QZ6Ai57jnboZDQwdzERnEfUqaUp5ggFgXIU5qPxCy8DgG/qXw3SyUx/LigyOHjsgyLejjWnQBHWBbADD0y07n+UDc+KuEcFCetOROy5nawTs1WFl6CkvNxyzxlrn5MUD1JzZajELw3yWfMwNDoND0H3L7E+7F1mrzAgMBAAECgYBfLHp+Wop2ALzdxGIHe3vDETfDrXaqp4Da9MiDXd4mX1Q28Cnw1MiwfslIhomBNXug3QZ0s1VrE8sMyshTxaRnW1GdmSMlwLoup0GTIsyx5yAnaomC4hHexnsX6dhzSzQSTPzkejM9S3ByaQHbCQkV9Xtii/wgyzbRR2MPsWL/CQJBAOa8Cc8fP8XFgo6QxCL1k3Qxw6xkhLUaXnO25dfV1Nnl1PXDp3VvTQomXbWR17RhS5W7OyijgBiw6DZeK7Nvb60CQQDLXh930U5pE6W9ipbjsj0Bc4c6UKdE9PPCUPXP3eWBc+cjaLdbnApr8wruqAqxy/h0qRRixNPMweK327E9MBkfAkEAryy71cBHzoLxaAOIpXIEjQbrJAr8pfJrGzcUsRTrELNpR11P2dyyhK40HxGmzo+/ruIDPAtFyXkmE4DTdNt50QJBALMsPfVGhxq0oLWZwM7jXjRFIMMUBAsQ9SIiSi/VhDrFbsMXo1Qm6lepTdxuWN3EoyXFQZyzZRdlSuZJvKH4GmkCQEaAlk2Lgr2A8XOOo1oxAGayBNIYQhT6+L4Vavll1ffdb5o2LT6XrIgWujo3CkY/uH8rzuKqgXaQ7lJkcfTLIhI="

export const localStorageKey = 'dc-nm-jxs-'

export const fxsLocalStorageKey = 'dc-nm-fxs-'
export const zmdfxsLocalStorageKey = 'dc-nm-zmdfxs-'
export const sdgjjxsLocalStorageKey = 'dc-nm-sdgjjxs-'

export const selectApi = '/backstage/manager/select.do'

export const cpbmsubstrpos = 7

export const sjfq = "2021-10-01"

export const drawerWidth = '90%'

export const tablePagination = {
    pageSize: 500,
    pageSizeOptions: ['100', '300', '500', '1000'],
    // hideOnSinglePage:true,
    showSizeChanger: true,
}

export const formItemConfig = {
    normal: {
        labelCol: {
            span: 9
        },
        wrapperCol: {
            span: 15
        }
    },
    normal2: {
        labelCol: {
            span: 8
        },
        wrapperCol: {
            span: 16
        }
    },
    normal3: {
        labelCol: {
            span: 6
        },
        wrapperCol: {
            span: 18
        }
    },
    full: {
        labelCol: {
            span: 3
        },
        wrapperCol: {
            span: 21
        }
    },
    full2: {
        labelCol: {
            span: 2
        },
        wrapperCol: {
            span: 22
        }
    },
}
